import React, {useEffect, useState} from "react";
import styles from "../styles/components/EditSermonForm.module.css";

const EditSermonForm = ({ sermon, onSave, onCancel }) => {
    // Reset the form if sermon becomes null
    useEffect(() => {
        if(!sermon) {
            setFormState({
                title: "",
                bible_text: "",
                description: "",
                rumble_url: "",
                spotify_link: "",
                youtube_url: "",
                sermon_date: "",
                sermon_id: "",
            });

        }
    }, [sermon]);



    const [formState, setFormState] = useState({
        title: sermon.title || "",
        bible_text: sermon.bible_text || "",
        description: sermon.description || "",
        rumble_url: sermon.rumble_url || "",
        spotify_link: sermon.spotify_link || "",
        youtube_url: sermon.youtube_url || "",
        sermon_date: sermon.sermon_date || "",
        sermon_id: sermon.sermon_id
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave({ ...sermon, ...formState });
    };

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <h3>Edit Sermon</h3>
            <label>
                Title:
                <input name="title" value={formState.title} onChange={handleChange} required />
            </label>

            <label>
                Bible Text:
                <input name="bible_text" value={formState.bible_text} onChange={handleChange} />
            </label>

            <label>
                Description:
                <textarea name="description" value={formState.description} onChange={handleChange}></textarea>
            </label>

            <label>
                Sermon Date:
                <input type="date" name="sermon_date" value={formState.sermon_date} onChange={handleChange} required />
            </label>

            <label>
                Rumble URL:
                <input name="rumble_url" value={formState.rumble_url} onChange={handleChange}  />
            </label>

            <label>
                Spotify Link:
                <input name="spotify_link" value={formState.spotify_link} onChange={handleChange}  />
            </label>

            <label>
                Youtube URL:
                <input name="youtube_url" value={formState.youtube_url} onChange={handleChange}  />
            </label>

            <div className={styles.buttonRow}>
                <button type="submit">Save</button>
                <button type="button" onClick={onCancel}>Cancel</button>
            </div>
        </form>
    );
};

export default EditSermonForm;
